var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreativeThinker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 119,
    viewBox: "0 0 154 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.108 25.1641L104.545 28.751V40.7529L142.755 37.9305C145.263 37.7472 147.327 36.3805 148.479 34.1445L153.108 25.1641Z",
    fill: "url(#paint0_linear_308_8080)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.545 39.6399L143.357 36.7703C145.866 36.587 147.929 35.2203 149.081 32.9844L148.479 34.1469C147.327 36.3828 145.263 37.7495 142.755 37.9328L104.545 40.7552V39.6346V39.6399Z",
    fill: "url(#paint1_linear_308_8080)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.755 37.9336L104.545 40.756V52.7579L132.408 50.7C134.916 50.5167 136.979 49.15 138.131 46.9141L142.76 37.9336H142.755Z",
    fill: "url(#paint2_linear_308_8080)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.548 51.641L133.008 49.5359C135.516 49.3527 137.58 47.986 138.732 45.75L138.129 46.9125C136.977 49.1484 134.914 50.5152 132.406 50.6984L104.543 52.7563V51.6357L104.548 51.641Z",
    fill: "url(#paint3_linear_308_8080)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.406 50.6992L104.543 52.7571V64.759L122.054 63.4656C124.562 63.2824 126.625 61.9157 127.777 59.6797L132.406 50.6992Z",
    fill: "url(#paint4_linear_308_8080)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.548 63.6382L122.656 62.2977C125.164 62.1144 127.227 60.7477 128.379 58.5117L127.777 59.6742C126.625 61.9102 124.562 63.2769 122.054 63.4601L104.543 64.7535V63.6329L104.548 63.6382Z",
    fill: "url(#paint5_linear_308_8080)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0859375 25.1641L48.6486 28.751V40.7529L10.4384 37.9305C7.93011 37.7472 5.86696 36.3805 4.71494 34.1445L0.0859375 25.1641Z",
    fill: "url(#paint6_linear_308_8080)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6511 39.6399L9.83866 36.7703C7.3304 36.587 5.26725 35.2203 4.11523 32.9844L4.71742 34.1469C5.86944 36.3828 7.93259 37.7495 10.4408 37.9328L48.6511 40.7552V39.6346V39.6399Z",
    fill: "url(#paint7_linear_308_8080)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4408 37.9336L48.651 40.756V52.7579L20.788 50.7C18.2797 50.5167 16.2166 49.15 15.0646 46.9141L10.4355 37.9336H10.4408Z",
    fill: "url(#paint8_linear_308_8080)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6502 51.641L20.1902 49.5359C17.682 49.3527 15.6188 47.986 14.4668 45.75L15.069 46.9125C16.221 49.1484 18.2842 50.5152 20.7924 50.6984L48.6555 52.7563V51.6357L48.6502 51.641Z",
    fill: "url(#paint9_linear_308_8080)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7871 50.6992L48.6502 52.7571V64.759L31.1395 63.4656C28.6313 63.2824 26.5681 61.9157 25.4161 59.6797L20.7871 50.6992Z",
    fill: "url(#paint10_linear_308_8080)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6494 63.6382L30.5418 62.2977C28.0335 62.1144 25.9704 60.7477 24.8184 58.5117L25.4205 59.6742C26.5726 61.9102 28.6357 63.2769 31.144 63.4601L48.6546 64.7535V63.6329L48.6494 63.6382Z",
    fill: "url(#paint11_linear_308_8080)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.2457 95.1733C68.2759 92.4347 60.1437 89.1253 53.9804 83.1871C44.5234 74.0758 42.2246 60.7752 42.2246 48.1921V21.4287L42.9158 21.1616C53.5929 17.0301 65.0973 14.1448 76.4761 12.8933L76.5965 12.8828L76.717 12.8933C88.0957 14.15 99.6002 17.0301 110.277 21.1616L110.968 21.4287V48.1921C110.968 60.7805 108.67 74.0758 99.2127 83.1871C93.0494 89.1253 84.9225 92.4347 76.9474 95.1733L76.5965 95.2938L76.2457 95.1733Z",
    fill: "url(#paint12_linear_308_8080)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.737 18.4082C49.9378 13.2817 63.5212 9.73141 76.5965 8.35946V2.76172C61.1386 4.3117 45.2565 8.83074 32.1602 14.7636L37.7317 18.4134L37.737 18.4082Z",
    fill: "url(#paint13_linear_308_8080)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5959 8.35938C63.5205 9.73132 49.932 13.2816 37.7363 18.4081L43.3079 22.1678C53.9117 18.0625 65.4475 15.1877 76.5959 13.9624V8.35938Z",
    fill: "url(#paint14_linear_308_8080)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7356 48.1924V18.4076L32.1641 14.7578V48.1924C32.1641 90.4243 56.9167 99.3681 76.6004 105.914V100.038C67.3215 96.9122 58.053 93.3462 50.8686 86.4236C40.4743 76.4063 37.7409 62.1109 37.7409 48.1924H37.7356Z",
    fill: "url(#paint15_linear_308_8080)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7377 18.4062V48.1911C37.7377 62.1095 40.4711 76.405 50.8654 86.4223C58.0445 93.3448 67.3183 96.9109 76.5972 100.037V94.1512C68.7426 91.4492 60.7465 88.2027 54.7299 82.4112C45.5138 73.5302 43.304 60.481 43.304 48.1911V22.166L37.7324 18.4062H37.7377Z",
    fill: "url(#paint16_linear_308_8080)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.461 18.4082C103.26 13.2817 89.6769 9.73141 76.6016 8.35946V2.76172C92.0595 4.3117 107.942 8.83074 121.038 14.7636L115.466 18.4134L115.461 18.4082Z",
    fill: "url(#paint17_linear_308_8080)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5957 8.35938C89.6711 9.73132 103.26 13.2816 115.455 18.4081L109.884 22.1678C99.2799 18.0625 87.7388 15.1877 76.5957 13.9624V8.35938Z",
    fill: "url(#paint18_linear_308_8080)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.461 48.1924V18.4076L121.032 14.7578V48.1924C121.032 90.4243 96.2795 99.3681 76.5957 105.914V100.038C85.8747 96.9122 95.1431 93.3462 102.328 86.4236C112.722 76.4063 115.455 62.1109 115.455 48.1924H115.461Z",
    fill: "url(#paint19_linear_308_8080)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.461 18.4062V48.1911C115.461 62.1095 112.728 76.405 102.333 86.4223C95.149 93.3448 85.8805 96.9109 76.6016 100.037V94.1512C84.4562 91.4492 92.4522 88.2027 98.4689 82.4112C107.685 73.5302 109.895 60.481 109.895 48.1911V22.166L115.466 18.4062H115.461Z",
    fill: "url(#paint20_linear_308_8080)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3066 22.1664C53.769 18.3176 68.0907 16.3069 76.5946 15.9717C85.0986 16.3069 99.4202 18.3124 109.883 22.1664C99.2789 18.0611 87.7378 15.1863 76.5946 13.9609C65.4463 15.1863 53.9104 18.0611 43.3066 22.1664Z",
    fill: "url(#paint21_radial_308_8080)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6858 78.2235C84.8197 90.8642 68.3669 90.8642 54.5008 78.2235C47.6672 71.9974 44.6615 63.6505 43.5566 55.0156C44.3526 65.1376 47.2064 75.1602 54.726 82.4074C60.7374 88.1989 68.7334 91.4507 76.5933 94.1475C84.4479 91.4455 92.444 88.1989 98.4606 82.4074C105.985 75.1602 108.834 65.1324 109.63 55.0156C108.525 63.6453 105.519 71.9921 98.6858 78.2183V78.2235Z",
    fill: "url(#paint22_radial_308_8080)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.7563 58.8418C62.6598 58.8418 50.7679 53.265 47.0552 45.6408C45.3639 42.169 45.3272 24.606 47.6679 23.2393C52.9619 20.1498 68.9226 17.4688 76.7563 17.4688C84.59 17.4688 100.551 20.1498 105.845 23.2393C108.185 24.606 108.149 42.1742 106.457 45.6408C102.745 53.265 90.8527 58.8418 76.7563 58.8418Z",
    fill: "url(#paint23_radial_308_8080)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5975 48.3425C65.5015 48.3425 56.1388 44.6351 53.2168 39.561C51.8868 37.2517 51.8554 23.9407 53.6986 23.0348C57.8668 20.9769 69.7168 18.7305 76.5975 18.7305C83.4782 18.7305 95.3282 20.9769 99.4964 23.0348C101.34 23.946 101.308 37.257 99.9782 39.561C97.0562 44.6299 87.6935 48.3425 76.5975 48.3425Z",
    fill: "url(#paint24_radial_308_8080)"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.923 46.448C36.923 55.0096 37.4518 58.3242 39.6721 66.1213C38.2425 60.3246 37.7294 54.2241 37.7294 48.1917V18.4069C49.3333 13.5318 62.194 10.081 74.6724 8.57812C67.2367 9.41595 60.6911 10.5104 54.2346 12.1441C53.889 11.72 53.313 11.5158 52.7579 11.6781C52.2238 11.8352 51.852 12.2803 51.7682 12.7935C50.3492 13.1862 48.9249 13.6051 47.4953 14.0554C46.9612 13.4951 46.1338 13.2595 45.3536 13.5266C44.5839 13.7884 44.0707 14.4639 43.9764 15.2179C41.8714 15.9458 39.7297 16.747 37.5304 17.6214L32.959 15.2808L36.923 18.5849V46.448Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M48.2836 25.2039C55.0914 25.2039 60.6101 19.6851 60.6101 12.8773C60.6101 6.06957 55.0914 0.550781 48.2836 0.550781C41.4758 0.550781 35.957 6.06957 35.957 12.8773C35.957 19.6851 41.4758 25.2039 48.2836 25.2039Z",
    fill: "url(#paint25_radial_308_8080)"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0723 102.372L42.3427 108.719V102.372H21.0723Z",
    fill: "#CD74D7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M132.111 102.372L110.846 108.719V102.372H132.111Z",
    fill: "#CD74D7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3435 108.72L26.0059 114.559V103.85L42.3435 108.72Z",
    fill: "#E195E9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M110.846 108.72L127.178 114.559V103.85L110.846 108.72Z",
    fill: "#E195E9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1747 111.635V118.27L26.0059 114.557L34.1747 111.635Z",
    fill: "#D17FDA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M119.012 111.635V118.27L127.175 114.557L119.012 111.635Z",
    fill: "#D17FDA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_308_8080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7148 76.4285H136.854L132.299 102.375H21.2653L16.7148 76.4285Z",
    fill: "#5F488A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_308_8080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8925 91.8234C35.9885 91.8234 35.2925 91.5634 34.8045 91.0434C34.3165 90.5154 34.0725 89.7674 34.0725 88.7994C34.0725 88.1194 34.2125 87.5154 34.4925 86.9874C34.7805 86.4514 35.1765 86.0354 35.6805 85.7394C36.1925 85.4434 36.7765 85.2954 37.4325 85.2954C38.1605 85.2954 38.7565 85.3914 39.2205 85.5834C39.2205 85.8154 39.1685 86.0834 39.0645 86.3874C38.9685 86.6834 38.8605 86.8994 38.7405 87.0354C38.4205 86.7794 38.0805 86.5634 37.7205 86.3874C37.3605 86.2114 37.0765 86.1234 36.8685 86.1234C36.6285 86.1874 36.4045 86.3394 36.1965 86.5794C35.9965 86.8114 35.8365 87.0954 35.7165 87.4314C35.5965 87.7674 35.5365 88.1114 35.5365 88.4634C35.5365 89.1914 35.6925 89.7394 36.0045 90.1074C36.3165 90.4674 36.7565 90.6474 37.3245 90.6474C37.6765 90.6474 38.0245 90.6034 38.3685 90.5154C38.7125 90.4274 39.0005 90.3074 39.2325 90.1554L39.3885 90.7554C39.1085 91.0754 38.7405 91.3354 38.2845 91.5354C37.8285 91.7274 37.3645 91.8234 36.8925 91.8234ZM41.1659 91.7634C40.9099 91.7634 40.6179 91.7394 40.2899 91.6914C40.3299 91.2994 40.3619 90.7594 40.3859 90.0714C40.4099 89.3754 40.4219 88.7354 40.4219 88.1514C40.4219 86.7834 40.3579 85.9434 40.2299 85.6314C40.4859 85.5354 40.8379 85.4594 41.2859 85.4034C41.7339 85.3394 42.1819 85.3074 42.6299 85.3074C43.4699 85.3074 44.1139 85.4914 44.5619 85.8594C45.0179 86.2194 45.2459 86.7394 45.2459 87.4194C45.2459 87.8114 45.1379 88.1634 44.9219 88.4754C44.7139 88.7794 44.4219 89.0234 44.0459 89.2074C44.6699 90.4314 45.1659 91.1994 45.5339 91.5114C45.2699 91.6074 44.9979 91.6714 44.7179 91.7034C44.4459 91.7434 44.1339 91.7634 43.7819 91.7634C43.6219 91.3394 43.2539 90.5914 42.6779 89.5194L42.4859 89.5314C42.3259 89.5314 42.0859 89.5114 41.7659 89.4714C41.7739 90.5994 41.8379 91.3394 41.9579 91.6914C41.6939 91.7394 41.4299 91.7634 41.1659 91.7634ZM42.9539 88.7634C43.2019 88.6354 43.4019 88.4634 43.5539 88.2474C43.7059 88.0314 43.7819 87.7874 43.7819 87.5154C43.7819 86.6674 43.3139 86.2434 42.3779 86.2434C42.1699 86.2434 41.9899 86.2634 41.8379 86.3034C41.8059 86.9114 41.7819 87.6474 41.7659 88.5114C42.2939 88.6794 42.6899 88.7634 42.9539 88.7634ZM46.4423 91.7274C46.5303 90.5354 46.5743 89.3234 46.5743 88.0914C46.5743 87.3554 46.5583 86.7914 46.5263 86.3994C46.5023 85.9994 46.4543 85.6554 46.3823 85.3674C46.8223 85.4234 47.5023 85.4514 48.4223 85.4514C49.5183 85.4514 50.3703 85.4234 50.9783 85.3674C50.9783 85.6314 50.9543 85.9154 50.9063 86.2194C50.8583 86.5154 50.7983 86.7154 50.7263 86.8194C50.5263 86.7154 50.2663 86.6354 49.9463 86.5794C49.6263 86.5234 49.2983 86.4954 48.9623 86.4954C48.6023 86.4954 48.2743 86.5194 47.9783 86.5674C47.9463 87.1914 47.9303 87.6954 47.9303 88.0794C48.2663 88.0954 48.5263 88.1034 48.7103 88.1034C49.1103 88.1034 49.4183 88.0954 49.6343 88.0794C49.8503 88.0554 50.0903 88.0194 50.3543 87.9714C50.3863 88.1794 50.4023 88.3554 50.4023 88.4994C50.4023 88.6194 50.3863 88.7994 50.3543 89.0394C49.2983 88.9754 48.4863 88.9474 47.9183 88.9554C47.9183 89.5874 47.9303 90.1034 47.9543 90.5034C48.2903 90.5674 48.6463 90.5994 49.0223 90.5994C49.3903 90.5994 49.7583 90.5714 50.1263 90.5154C50.4943 90.4594 50.7943 90.3794 51.0263 90.2754C51.0263 90.5394 51.0023 90.8194 50.9543 91.1154C50.9063 91.4114 50.8463 91.6154 50.7743 91.7274C50.2383 91.6714 49.4743 91.6434 48.4823 91.6434C47.5703 91.6434 46.8903 91.6714 46.4423 91.7274ZM56.9142 91.7514C56.6662 91.7514 56.3982 91.7234 56.1102 91.6674C55.8622 90.9554 55.6862 90.4594 55.5822 90.1794C55.1582 90.1554 54.6942 90.1434 54.1902 90.1434C53.6462 90.1434 53.2622 90.1594 53.0382 90.1914C52.9022 90.5514 52.7262 91.0434 52.5102 91.6674C52.3342 91.7154 52.1742 91.7394 52.0302 91.7394C51.8462 91.7394 51.6582 91.7154 51.4662 91.6674C51.6902 91.2674 52.0862 90.3234 52.6542 88.8354C53.2222 87.3474 53.6462 86.1834 53.9262 85.3434C54.2062 85.3034 54.4422 85.2834 54.6342 85.2834C54.8342 85.2834 55.0542 85.3034 55.2942 85.3434C55.5742 86.1834 55.9982 87.3474 56.5662 88.8354C57.1342 90.3234 57.5302 91.2674 57.7542 91.6674C57.4982 91.7234 57.2182 91.7514 56.9142 91.7514ZM54.6462 89.3154C54.8142 89.3154 55.0182 89.3074 55.2582 89.2914C54.8822 88.2514 54.5662 87.4354 54.3102 86.8434C54.0542 87.4674 53.7422 88.2794 53.3742 89.2794C53.7662 89.3034 54.1902 89.3154 54.6462 89.3154ZM60.0021 91.7634C59.7701 91.7634 59.4861 91.7394 59.1501 91.6914C59.1901 91.2754 59.2221 90.7234 59.2461 90.0354C59.2701 89.3394 59.2821 88.6914 59.2821 88.0914C59.2821 87.5794 59.2661 87.0594 59.2341 86.5314C58.2501 86.5394 57.6381 86.5914 57.3981 86.6874C57.3581 86.4074 57.3381 86.1714 57.3381 85.9794C57.3381 85.8194 57.3581 85.6194 57.3981 85.3794C57.7261 85.4114 58.1661 85.4394 58.7181 85.4634C59.2781 85.4794 59.8061 85.4874 60.3021 85.4874C61.4941 85.4874 62.2301 85.4354 62.5101 85.3314C62.5501 85.5874 62.5701 85.7994 62.5701 85.9674C62.5701 86.1754 62.5501 86.3994 62.5101 86.6394C62.0461 86.5994 61.4381 86.5674 60.6861 86.5434C60.6461 87.3674 60.6261 88.1754 60.6261 88.9674C60.6261 90.4314 60.6901 91.3394 60.8181 91.6914C60.6021 91.7394 60.3301 91.7634 60.0021 91.7634ZM64.2402 91.7634C63.9842 91.7634 63.6922 91.7394 63.3642 91.6914C63.4522 90.4594 63.4962 89.2794 63.4962 88.1514C63.4962 86.6794 63.4322 85.7514 63.3042 85.3674C63.5682 85.3194 63.8482 85.2954 64.1442 85.2954C64.3842 85.2954 64.6602 85.3194 64.9722 85.3674C64.9322 85.7834 64.9002 86.3394 64.8762 87.0354C64.8522 87.7234 64.8402 88.3674 64.8402 88.9674C64.8402 90.4314 64.9042 91.3394 65.0322 91.6914C64.7682 91.7394 64.5042 91.7634 64.2402 91.7634ZM68.7284 91.7994C68.4804 91.7994 68.2644 91.6874 68.0804 91.4634C67.8964 91.2394 67.7324 90.9474 67.5884 90.5874C67.4444 90.2194 67.2644 89.6994 67.0484 89.0274C66.8004 88.2594 66.5844 87.6194 66.4004 87.1074C66.2164 86.5954 65.9884 86.0754 65.7164 85.5474C66.2524 85.3794 66.8484 85.2954 67.5044 85.2954C67.5684 85.6794 67.6804 86.1914 67.8404 86.8314C68.0004 87.4634 68.1644 88.0434 68.3324 88.5714C68.6684 89.5474 68.9564 90.2474 69.1964 90.6714C69.6764 89.2314 70.0244 88.1114 70.2404 87.3114C70.4644 86.5034 70.5764 85.9434 70.5764 85.6314C70.5764 85.5274 70.5684 85.4594 70.5524 85.4274C70.9124 85.3394 71.3244 85.2954 71.7884 85.2954C71.5164 86.0554 71.1804 87.0514 70.7804 88.2834C70.3884 89.5074 70.0724 90.5354 69.8324 91.3674L68.7284 91.7994ZM72.5399 91.7274C72.6279 90.5354 72.6719 89.3234 72.6719 88.0914C72.6719 87.3554 72.6559 86.7914 72.6239 86.3994C72.5999 85.9994 72.5519 85.6554 72.4799 85.3674C72.9199 85.4234 73.5999 85.4514 74.5199 85.4514C75.6159 85.4514 76.4679 85.4234 77.0759 85.3674C77.0759 85.6314 77.0519 85.9154 77.0039 86.2194C76.9559 86.5154 76.8959 86.7154 76.8239 86.8194C76.6239 86.7154 76.3639 86.6354 76.0439 86.5794C75.7239 86.5234 75.3959 86.4954 75.0599 86.4954C74.6999 86.4954 74.3719 86.5194 74.0759 86.5674C74.0439 87.1914 74.0279 87.6954 74.0279 88.0794C74.3639 88.0954 74.6239 88.1034 74.8079 88.1034C75.2079 88.1034 75.5159 88.0954 75.7319 88.0794C75.9479 88.0554 76.1879 88.0194 76.4519 87.9714C76.4839 88.1794 76.4999 88.3554 76.4999 88.4994C76.4999 88.6194 76.4839 88.7994 76.4519 89.0394C75.3959 88.9754 74.5839 88.9474 74.0159 88.9554C74.0159 89.5874 74.0279 90.1034 74.0519 90.5034C74.3879 90.5674 74.7439 90.5994 75.1199 90.5994C75.4879 90.5994 75.8559 90.5714 76.2239 90.5154C76.5919 90.4594 76.8919 90.3794 77.1239 90.2754C77.1239 90.5394 77.0999 90.8194 77.0519 91.1154C77.0039 91.4114 76.9439 91.6154 76.8719 91.7274C76.3359 91.6714 75.5719 91.6434 74.5799 91.6434C73.6679 91.6434 72.9879 91.6714 72.5399 91.7274ZM83.088 91.7634C82.856 91.7634 82.572 91.7394 82.236 91.6914C82.276 91.2754 82.308 90.7234 82.332 90.0354C82.356 89.3394 82.368 88.6914 82.368 88.0914C82.368 87.5794 82.352 87.0594 82.32 86.5314C81.336 86.5394 80.724 86.5914 80.484 86.6874C80.444 86.4074 80.424 86.1714 80.424 85.9794C80.424 85.8194 80.444 85.6194 80.484 85.3794C80.812 85.4114 81.252 85.4394 81.804 85.4634C82.364 85.4794 82.892 85.4874 83.388 85.4874C84.58 85.4874 85.316 85.4354 85.596 85.3314C85.636 85.5874 85.656 85.7994 85.656 85.9674C85.656 86.1754 85.636 86.3994 85.596 86.6394C85.132 86.5994 84.524 86.5674 83.772 86.5434C83.732 87.3674 83.712 88.1754 83.712 88.9674C83.712 90.4314 83.776 91.3394 83.904 91.6914C83.688 91.7394 83.416 91.7634 83.088 91.7634ZM87.3261 91.7634C87.0701 91.7634 86.7781 91.7394 86.4501 91.6914C86.4901 91.2674 86.5221 90.7154 86.5461 90.0354C86.5701 89.3554 86.5821 88.7274 86.5821 88.1514C86.5821 86.6794 86.5181 85.7514 86.3901 85.3674C86.6541 85.3194 86.9341 85.2954 87.2301 85.2954C87.4701 85.2954 87.7461 85.3194 88.0581 85.3674C87.9941 86.0634 87.9541 86.9634 87.9381 88.0674C88.4021 88.0914 88.9221 88.1034 89.4981 88.1034C89.7381 88.1034 90.0261 88.0954 90.3621 88.0794C90.3621 86.6394 90.2981 85.7354 90.1701 85.3674C90.4341 85.3194 90.7141 85.2954 91.0101 85.2954C91.2501 85.2954 91.5261 85.3194 91.8381 85.3674C91.7981 85.7994 91.7661 86.3514 91.7421 87.0234C91.7181 87.6954 91.7061 88.3234 91.7061 88.9074C91.7061 90.4114 91.7701 91.3394 91.8981 91.6914C91.6341 91.7394 91.3701 91.7634 91.1061 91.7634C90.8501 91.7634 90.5581 91.7394 90.2301 91.6914C90.2861 90.9874 90.3261 90.0834 90.3501 88.9794C89.7421 88.9634 89.2661 88.9554 88.9221 88.9554C88.6261 88.9554 88.2941 88.9634 87.9261 88.9794C87.9261 90.4514 87.9901 91.3554 88.1181 91.6914C87.8541 91.7394 87.5901 91.7634 87.3261 91.7634ZM94.0995 91.7634C93.8435 91.7634 93.5515 91.7394 93.2235 91.6914C93.3115 90.4594 93.3555 89.2794 93.3555 88.1514C93.3555 86.6794 93.2915 85.7514 93.1635 85.3674C93.4275 85.3194 93.7075 85.2954 94.0035 85.2954C94.2435 85.2954 94.5195 85.3194 94.8315 85.3674C94.7915 85.7834 94.7595 86.3394 94.7355 87.0354C94.7115 87.7234 94.6995 88.3674 94.6995 88.9674C94.6995 90.4314 94.7635 91.3394 94.8915 91.6914C94.6275 91.7394 94.3635 91.7634 94.0995 91.7634ZM96.7158 91.7634C96.5558 91.7634 96.3598 91.7394 96.1278 91.6914C96.1918 90.8594 96.2238 89.6794 96.2238 88.1514C96.2238 86.6714 96.1798 85.7434 96.0918 85.3674C96.3158 85.3194 96.5758 85.2954 96.8718 85.2954C97.1038 85.2954 97.3998 85.3194 97.7598 85.3674C98.0158 85.8714 98.4078 86.5874 98.9358 87.5154C99.4718 88.4434 99.9718 89.2914 100.436 90.0594C100.452 89.2114 100.46 88.5554 100.46 88.0914C100.46 86.6034 100.416 85.6954 100.328 85.3674C100.496 85.3194 100.664 85.2954 100.832 85.2954C101.008 85.2954 101.208 85.3194 101.432 85.3674C101.368 86.4074 101.336 87.5874 101.336 88.9074C101.336 90.3714 101.38 91.2994 101.468 91.6914C101.252 91.7394 100.996 91.7634 100.7 91.7634C100.428 91.7634 100.124 91.7394 99.7878 91.6914C99.5318 91.2034 99.1398 90.4994 98.6118 89.5794C98.0918 88.6514 97.5958 87.7914 97.1238 86.9994C97.1078 87.8474 97.0998 88.5034 97.0998 88.9674C97.0998 90.4074 97.1438 91.3154 97.2318 91.6914C97.0638 91.7394 96.8918 91.7634 96.7158 91.7634ZM103.603 91.7634C103.347 91.7634 103.055 91.7394 102.727 91.6914C102.767 91.2674 102.799 90.7154 102.823 90.0354C102.847 89.3554 102.859 88.7274 102.859 88.1514C102.859 86.6794 102.795 85.7514 102.667 85.3674C102.931 85.3194 103.211 85.2954 103.507 85.2954C103.747 85.2954 104.023 85.3194 104.335 85.3674C104.263 86.2234 104.219 87.2194 104.203 88.3554C105.067 87.4354 105.643 86.7714 105.931 86.3634C106.219 85.9474 106.363 85.6354 106.363 85.4274C106.883 85.3394 107.435 85.2954 108.019 85.2954C107.283 86.0074 106.463 86.8754 105.559 87.8994C106.767 89.8434 107.683 91.0474 108.307 91.5114C108.043 91.6074 107.771 91.6714 107.491 91.7034C107.211 91.7434 106.891 91.7634 106.531 91.7634C106.243 91.2674 105.611 90.3274 104.635 88.9434C104.515 89.0714 104.371 89.2354 104.203 89.4354C104.211 90.6274 104.275 91.3794 104.395 91.6914C104.131 91.7394 103.867 91.7634 103.603 91.7634ZM109.009 91.7274C109.097 90.5354 109.141 89.3234 109.141 88.0914C109.141 87.3554 109.125 86.7914 109.093 86.3994C109.069 85.9994 109.021 85.6554 108.949 85.3674C109.389 85.4234 110.069 85.4514 110.989 85.4514C112.085 85.4514 112.937 85.4234 113.545 85.3674C113.545 85.6314 113.521 85.9154 113.473 86.2194C113.425 86.5154 113.365 86.7154 113.293 86.8194C113.093 86.7154 112.833 86.6354 112.513 86.5794C112.193 86.5234 111.865 86.4954 111.529 86.4954C111.169 86.4954 110.841 86.5194 110.545 86.5674C110.513 87.1914 110.497 87.6954 110.497 88.0794C110.833 88.0954 111.093 88.1034 111.277 88.1034C111.677 88.1034 111.985 88.0954 112.201 88.0794C112.417 88.0554 112.657 88.0194 112.921 87.9714C112.953 88.1794 112.969 88.3554 112.969 88.4994C112.969 88.6194 112.953 88.7994 112.921 89.0394C111.865 88.9754 111.053 88.9474 110.485 88.9554C110.485 89.5874 110.497 90.1034 110.521 90.5034C110.857 90.5674 111.213 90.5994 111.589 90.5994C111.957 90.5994 112.325 90.5714 112.693 90.5154C113.061 90.4594 113.361 90.3794 113.593 90.2754C113.593 90.5394 113.569 90.8194 113.521 91.1154C113.473 91.4114 113.413 91.6154 113.341 91.7274C112.805 91.6714 112.041 91.6434 111.049 91.6434C110.137 91.6434 109.457 91.6714 109.009 91.7274ZM115.557 91.7634C115.301 91.7634 115.009 91.7394 114.681 91.6914C114.721 91.2994 114.753 90.7594 114.777 90.0714C114.801 89.3754 114.813 88.7354 114.813 88.1514C114.813 86.7834 114.749 85.9434 114.621 85.6314C114.877 85.5354 115.229 85.4594 115.677 85.4034C116.125 85.3394 116.573 85.3074 117.021 85.3074C117.861 85.3074 118.505 85.4914 118.953 85.8594C119.409 86.2194 119.637 86.7394 119.637 87.4194C119.637 87.8114 119.529 88.1634 119.313 88.4754C119.105 88.7794 118.813 89.0234 118.437 89.2074C119.061 90.4314 119.557 91.1994 119.925 91.5114C119.661 91.6074 119.389 91.6714 119.109 91.7034C118.837 91.7434 118.525 91.7634 118.173 91.7634C118.013 91.3394 117.645 90.5914 117.069 89.5194L116.877 89.5314C116.717 89.5314 116.477 89.5114 116.157 89.4714C116.165 90.5994 116.229 91.3394 116.349 91.6914C116.085 91.7394 115.821 91.7634 115.557 91.7634ZM117.345 88.7634C117.593 88.6354 117.793 88.4634 117.945 88.2474C118.097 88.0314 118.173 87.7874 118.173 87.5154C118.173 86.6674 117.705 86.2434 116.769 86.2434C116.561 86.2434 116.381 86.2634 116.229 86.3034C116.197 86.9114 116.173 87.6474 116.157 88.5114C116.685 88.6794 117.081 88.7634 117.345 88.7634Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_308_8080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.7531 64.6865C73.1181 64.4819 72.4802 64.2624 72.0292 63.7435C71.688 63.352 71.4053 62.9103 71.0957 62.4899L71.1822 62.4062H81.8482C81.5134 63.2953 80.9379 63.9463 80.101 64.361C79.8286 64.4959 79.532 64.5786 79.2465 64.6856H73.7531V64.6865Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5058 41.5202C95.225 42.1526 94.7368 42.3869 94.0543 42.3442C93.4397 42.306 92.8214 42.3405 92.204 42.3349C91.5252 42.3284 91.0445 41.8513 91.0528 41.2031C91.0612 40.5745 91.5391 40.1169 92.2049 40.1123C92.8214 40.1076 93.4406 40.143 94.0552 40.103C94.7396 40.0583 95.2259 40.2918 95.5048 40.9269V41.5212L95.5058 41.5202Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4058 53.4535H80.9561V53.0415C80.9561 49.9857 80.9608 46.9289 80.9487 43.8731C80.9478 43.5736 80.8994 43.2453 80.7711 42.9803C79.6999 40.7558 78.6093 38.5407 77.5158 36.3265C77.3121 35.9145 76.9588 35.7155 76.492 35.7173C76.0253 35.7201 75.6794 35.9284 75.4767 36.3404C74.3953 38.5323 73.313 40.7242 72.2539 42.9282C72.1154 43.2156 72.054 43.5671 72.0521 43.8898C72.0373 46.9215 72.0438 49.9531 72.0438 52.9839C72.0438 53.1308 72.0438 53.2768 72.0438 53.4479H68.6406C68.4574 52.8193 68.3077 52.185 68.0874 51.575C67.7043 50.5158 67.0525 49.6174 66.33 48.7609C62.2574 43.9335 62.0203 37.0872 65.813 32.0366C68.1562 28.9175 71.2906 27.0994 75.2061 26.7358C81.9799 26.1071 88.0581 30.4761 89.5263 37.1141C90.4729 41.3919 89.5133 45.2801 86.7303 48.681C85.7298 49.9029 84.9134 51.2049 84.5545 52.7598C84.5025 52.9857 84.4569 53.2136 84.4058 53.4544V53.4535Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7053 55.7188H84.2464C84.4769 57.5377 84.0316 59.0071 82.3783 59.8124C81.9395 60.0263 81.4067 60.1361 80.9157 60.1416C77.971 60.1714 75.0262 60.1649 72.0815 60.1537C70.1605 60.1463 68.7211 58.6862 68.7044 56.7594C68.7016 56.4264 68.7044 56.0926 68.7044 55.7188H68.7053Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3008 45.2135C75.7736 45.6748 77.2325 45.6795 78.7081 45.207V53.453H74.3008V45.2135Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7239 35.2479C61.6533 35.8142 61.4561 36.1527 61.0489 36.3406C60.6416 36.5284 60.2288 36.4996 59.9061 36.202C59.299 35.6422 58.7076 35.061 58.1525 34.45C57.7471 34.0045 57.8168 33.3517 58.2408 32.9472C58.6639 32.5426 59.3055 32.511 59.749 32.9258C60.3264 33.4642 60.8871 34.0231 61.418 34.6062C61.5956 34.8015 61.6579 35.1 61.7249 35.2488L61.7239 35.2479Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1307 33.8746C95.0424 34.0383 94.9457 34.3433 94.7504 34.56C94.2706 35.0901 93.7536 35.5876 93.2376 36.0842C92.7392 36.5641 92.0651 36.565 91.6178 36.1065C91.178 35.6555 91.1808 35.0027 91.6504 34.5135C92.1636 33.9797 92.6862 33.4543 93.2236 32.9447C93.577 32.6099 94.0028 32.5318 94.4557 32.7401C94.8769 32.9345 95.0721 33.2878 95.1298 33.8746H95.1307Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0813 49.8238C58.5597 49.7726 58.2157 49.5885 58.0139 49.1858C57.8196 48.798 57.8131 48.3851 58.0976 48.0717C58.6852 47.4245 59.3008 46.7968 59.9498 46.2118C60.3543 45.8473 60.9772 45.9366 61.365 46.3188C61.7527 46.7 61.8569 47.3222 61.4933 47.7304C60.9047 48.3926 60.2585 49.0054 59.6113 49.6117C59.4635 49.7494 59.2106 49.7745 59.0795 49.8238H59.0813Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1263 48.5731C95.0854 49.1097 94.9096 49.4612 94.5135 49.6705C94.1044 49.8872 93.6711 49.8825 93.3354 49.5766C92.7069 49.0037 92.0988 48.4048 91.5316 47.7715C91.1438 47.3391 91.2359 46.6928 91.6524 46.3003C92.0588 45.9181 92.6827 45.8623 93.1011 46.2454C93.7111 46.8025 94.2894 47.3958 94.852 48.0003C95.0082 48.1686 95.0612 48.4336 95.1253 48.5731H95.1263Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6868 42.3297C59.3168 42.3297 58.9467 42.3381 58.5766 42.3279C57.9546 42.3102 57.4897 41.8192 57.4962 41.2017C57.5027 40.6019 57.9657 40.1192 58.571 40.1099C59.3354 40.0988 60.1006 40.0988 60.8658 40.1099C61.4739 40.1183 61.937 40.5972 61.9463 41.1971C61.9556 41.8155 61.4916 42.3102 60.8714 42.3288C60.4772 42.34 60.082 42.3307 59.6868 42.3307V42.3297Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5 39.2422C77.136 40.5134 77.7302 41.701 78.3448 42.9304C77.1202 43.4289 75.9207 43.4205 74.6543 42.9388C75.2643 41.7168 75.864 40.5162 76.5 39.2431V39.2422Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_308_8080",
    x: 16.7148,
    y: 76.4287,
    width: 120.139,
    height: 28.9463,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_308_8080"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_308_8080",
    x: 30.0725,
    y: 85.2832,
    width: 93.852,
    height: 14.54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_308_8080"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_308_8080",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_308_8080",
    x: 53.4961,
    y: 25.6758,
    width: 46.0097,
    height: 47.0107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_308_8080"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_308_8080",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0166667 0 0 0 0 0.0166667 0 0 0 0 0.0166667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_308_8080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_308_8080",
    x1: 104.545,
    y1: 32.9611,
    x2: 153.108,
    y2: 32.9611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_308_8080",
    x1: 104.545,
    y1: 36.8698,
    x2: 149.076,
    y2: 36.8698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E6F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_308_8080",
    x1: 0.0833329,
    y1: 45.3484,
    x2: 142.755,
    y2: 45.3484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_308_8080",
    x1: 0.0866246,
    y1: 49.2532,
    x2: 138.732,
    y2: 49.2532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E6F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_308_8080",
    x1: 0.0866033,
    y1: 57.7317,
    x2: 132.406,
    y2: 57.7317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_308_8080",
    x1: 0.086611,
    y1: 61.6379,
    x2: 128.379,
    y2: 61.6379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E6F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_308_8080",
    x1: 0.0859375,
    y1: 32.9611,
    x2: 48.6486,
    y2: 32.9611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4869"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_308_8080",
    x1: 4.11523,
    y1: 36.8698,
    x2: 48.6511,
    y2: 36.8698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA9CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_308_8080",
    x1: 10.4408,
    y1: 45.3484,
    x2: 0.612,
    y2: 45.3484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4869"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_308_8080",
    x1: 14.4668,
    y1: 49.2532,
    x2: 0.611196,
    y2: 49.2532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA9CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_308_8080",
    x1: 20.7871,
    y1: 57.7317,
    x2: 0.611136,
    y2: 57.7317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4869"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_308_8080",
    x1: 24.8184,
    y1: 61.6379,
    x2: 0.610332,
    y2: 61.6379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA9CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_308_8080",
    x1: 76.5965,
    y1: 95.2938,
    x2: 76.5965,
    y2: 12.8776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40526F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717F8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_308_8080",
    x1: 32.1654,
    y1: 10.5849,
    x2: 76.5965,
    y2: 10.5849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CDE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDBF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_308_8080",
    x1: 37.7363,
    y1: 15.2662,
    x2: 76.5959,
    y2: 15.2662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41475E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_308_8080",
    x1: 54.3822,
    y1: 105.914,
    x2: 54.3822,
    y2: 14.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C0D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_308_8080",
    x1: 57.1701,
    y1: 100.037,
    x2: 57.1701,
    y2: 18.4062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#546381"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_308_8080",
    x1: 76.5963,
    y1: 10.5849,
    x2: 121.033,
    y2: 10.5849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C0D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737A99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_308_8080",
    x1: 76.5957,
    y1: 0.551855,
    x2: 115.461,
    y2: 0.551855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41475E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_308_8080",
    x1: 98.8139,
    y1: 105.914,
    x2: 98.8139,
    y2: 14.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E3A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_308_8080",
    x1: 96.0287,
    y1: 100.037,
    x2: 96.0287,
    y2: 18.4062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C0D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_308_8080",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.5946 70.1269) scale(74.682 74.682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#DFE2ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C3C9DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#AFB7D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#9FA9CA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_308_8080",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.3943 54.5286) scale(42.9597 42.9597)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA5B2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_308_8080",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.0113 -6.07425) scale(65.7236 66.3875)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEB6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927793,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_308_8080",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.9901 -21.7576) scale(65.4405)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEB6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_308_8080",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.2836 12.8773) scale(12.3266)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5C3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#7A90AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#556476"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#37404C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#1F252B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0E1114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#040505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativeThinker);
export default __webpack_public_path__ + "static/media/creative-thinker.e576b3c66937db3c02b2fa390fcb30d8.svg";
export { ForwardRef as ReactComponent };